import { render } from "./CarDetailsSwiper.vue?vue&type=template&id=5800d966"
import script from "./CarDetailsSwiper.vue?vue&type=script&lang=js"
export * from "./CarDetailsSwiper.vue?vue&type=script&lang=js"

import "./CarDetailsSwiper.vue?vue&type=style&index=0&id=5800d966&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__